import { render, staticRenderFns } from "./evaluationStar.vue?vue&type=template&id=6755f6b0&scoped=true"
import script from "./evaluationStar.vue?vue&type=script&lang=js"
export * from "./evaluationStar.vue?vue&type=script&lang=js"
import style0 from "./evaluationStar.vue?vue&type=style&index=0&id=6755f6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6755f6b0",
  null
  
)

export default component.exports